import angular from 'angular';

export default angular.module('liveChatModule', ['shared']);



// WEBPACK FOOTER //
// ./modules/liveChat/liveChat.module.js